"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
class UserHasReachedMaximumNumberOfClassCourses extends client_library_1.ExtendableError {
    constructor() {
        super('You are trying to exceed the limit for the number of courses per class');
    }
}
exports.default = UserHasReachedMaximumNumberOfClassCourses;
//# sourceMappingURL=UserHasReachedMaximumNumberOfClassCourses.js.map